import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlayBoardService } from '../../services/play-board.service';
import { joinGame, socket } from '../../helpers/socketio';
import { Router } from '@angular/router';
import { CommonServiceService } from '../../services/common-service.service';
import { DecryptionService } from '../../services/decryption.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent implements OnInit {
  challangeData: any;
  challengePopup: boolean = false;
  challangeSendID: any;
  gameModeImg = '';
  constructor(
    private playService: PlayBoardService,
    private toasterapi: CommonServiceService,
    private router: Router,private ngZone: NgZone,
    private cdref: ChangeDetectorRef,private decryptionApi: DecryptionService
  ) {
    
  }

  ngOnInit(): void {
    socket.on('startGame', (data) => {
      if (this.challangeSendID) {
        this.router.navigate(['play', data.data.gameId])
      }
    });

    socket.on('closePopUp',(data)=>{
      this.ngZone.run(() => {
      this.challengePopup = false;
      })
    })

    socket.on('sendChallange', (data: any) => {
      this.ngZone.run(() => {
        this.challengePopup = true;
        this.challangeData = data;
        const gameModeImages: any = {
          bullet: '/assets/icon-image/bullet-img.svg',
          blitz: '/assets/icon-image/blitz-img.svg',
          rapid: '/assets/icon-image/rapid-img.svg',
        };
        this.gameModeImg = gameModeImages[data.gameMode] || '';
        this.cdref.detectChanges();
      })
    });

    socket.on('challangeResult', (data: any) => {
      this.ngZone.run(() => {
      if (data.game) {
        this.router.navigate(['play', data.game?.gameId])
      } else {
        this.toasterapi.deciderequest(data);
        this.cdref.detectChanges();
      }
    })
    });
  }

  accept(data: string) {
    const playersideChange = this.challangeData.playedAS;

    var playerside =
      playersideChange === 'B' ? 'W' : playersideChange === 'W' ? 'B' : 'R';

    var formvalue = {
      gameMode: this.challangeData.gameMode,
      gameType: this.challangeData.gameType,
      time: this.challangeData.time,
      playedAS: playerside,
      ratedGame: this.challangeData.ratedGame,
    };

    this.playService.createData(formvalue).subscribe((res) => {
      const decrypt=  this.decryptionApi.decrypt(res.payload);
      const jsondecrpt=JSON.parse(decrypt);
      
      this.challangeSendID = jsondecrpt.gameId;
      var challangeAccept = {
        username: this.challangeData.sentChallange,
        game: jsondecrpt,
      };
      this.emitChallengeDecision(challangeAccept);
      this.challengePopup = false;
      joinGame(jsondecrpt.gameId);
    });
  }

  reject(data: string) {
    let rejectdata = {
      username: this.challangeData.sentChallange,
      rejectReq: data,
    };
    this.emitChallengeDecision(rejectdata);
    this.challengePopup = false;
  }

  emitChallengeDecision(decisionData: any) {
    socket.emit('decideChallange', decisionData);
  }
}
